export default __webpack_public_path__ + "static/ben-burns@2x-2a68e22eb09a63a7222cd8db723a2bdb.png";